'use client';

import { createStore } from 'zustand';

import { PatientOption, ScheduleAgeRange } from '@/types/patient-selection.types';
import { AnalyticsScheduleType } from '@/types/enums/analytics/search/search-analytics.enum';

export interface PatientSelectionRequest {
  ageRange: ScheduleAgeRange;
  scheduleType?: AnalyticsScheduleType;
  canSearchAnotherOption?: boolean;
  onSelectPatient?: (patient: PatientOption) => void;
}

export type PatientSelectionState = {
  isOpen: boolean;
  request: PatientSelectionRequest | null;
  pendingPatient: PatientOption | null;
};

const initialState: PatientSelectionState = {
  isOpen: false,
  request: null,
  pendingPatient: null,
};

export const patientSelectionStore = createStore<PatientSelectionState>(() => ({ ...initialState }));

export const openPatientSelection = (request: PatientSelectionRequest) => {
  patientSelectionStore.setState({ isOpen: true, request, pendingPatient: null });
};

export const closePatientSelection = () => {
  patientSelectionStore.setState({ ...initialState });
};

export const setPendingPatient = (patient: PatientOption) => {
  patientSelectionStore.setState({ pendingPatient: patient });
};

export const clearPendingPatient = () => {
  patientSelectionStore.setState({ pendingPatient: null });
};

export const selectPatient = (patient: PatientOption) => {
  const { request } = patientSelectionStore.getState();

  closePatientSelection();
  request?.onSelectPatient?.(patient);
};
